const API_URL = 'https://service-iniushop.xyz/api';
const STOREFRONT_TOKEN = 'ea525b3f4dd9eafcc1dbaac99ae8f4f1';
const D5CC_CODE = 'INIUVDAYGIFT';
const LOVE_DISCOUNT = 'INIULOVE15';

// 全局状态
let userAnswers = [];
let customerId;


const MAX_DISPLAY_PC = 6;    // PC端显示前6个
const MAX_DISPLAY_MOBILE = 2; // 移动端显示前2个

// 核心：判断是否为移动端（通用的屏幕宽度判断法）
function isMobile() {
  // 通常以768px为分界，小于等于768px判定为移动端，可根据你的需求调整
  return window.innerWidth <= 768;
}


// 滚动到 box3 并显示 GiftFinder
function scrollToGiftFinder() {
    const box3 = document.querySelector('.box3');
    box3.scrollIntoView({ behavior: 'smooth' });
    
    // 延迟显示 GiftFinder，确保滚动完成
    setTimeout(() => {
        showGiftFinder();
    }, 800);
}

// 直接显示 GiftFinder（从 box3 按钮点击）
function showGiftFinder() {
    document.getElementById('finderIntro').style.display = 'none';
    document.getElementById('quizContainer').style.display = 'block';
    document.getElementById('resultContainer').style.display = 'none';
    
    // 重置状态
    resetQuiz();
}

// 更新进度条
function updateProgressBar(step) {
  const segments = document.querySelectorAll('.progress-segment');
  segments.forEach((segment, index) => {
    if (index == step) {
      segment.classList.add('active');
    } else {
      segment.classList.remove('active');
    }
  });
}

// 跳转到问题
function goToQuestion(questionNumber) {
  // 隐藏所有问题
  document.querySelectorAll('.question-container').forEach(question => {
    question.style.display = 'none';
  });
  
  if(questionNumber == 4){
    const giftFinderContainer = document.getElementById('giftFinderContainer'); 
    const persona = determinePersonaType();
    if (persona && persona.url) {
      // 使用模板字符串拼接背景图片样式
      giftFinderContainer.style.backgroundImage = `url(${persona.url})`;
      
      // 可选：补充背景图片的常用样式，保证显示效果
      giftFinderContainer.style.backgroundSize = 'cover'; // 覆盖整个容器
      giftFinderContainer.style.backgroundPosition = 'center'; // 居中显示
      giftFinderContainer.style.backgroundRepeat = 'no-repeat'; // 不重复
    } 
    document.getElementById('resultContainer').style.display = 'block'; 
    filterAndDisplayProducts();
  } else {
    const question = document.getElementById(`question${questionNumber}`);
    if (question) {
      question.style.display = 'block';
    }
  }
 
  // 更新进度条
  updateProgressBar(questionNumber - 1);
}

// 选择选项
function selectOption(element, questionId, value) {
  const questionNumber = parseInt(questionId.replace('question', ''));
  
  // 移除同问题其他选项的选中状态
  const options = document.querySelectorAll(`#${questionId} .option`);
  options.forEach(opt => {
    opt.classList.remove('selected');
  });
  
  // 选中当前选项
  element.classList.add('selected');
  
  // 修复：更新或设置答案
  userAnswers[questionNumber - 1] = value;
  
  // 自动进入下一题或结果
  setTimeout(() => {
    goToQuestion(questionNumber + 1);
  }, 400);
}

const personaTypes = {
  // 1. The Designated Adult（条件是题1选for-partner+题3不选home）
  'for-partner_not-home': {
    number: '01',
    type: 'The Designated Adult',
    img: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/1_23163fe5-79cc-49d0-9382-9ac79c1ec499.png?v=1768343387',
    url: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/1_1e398cc9-8787-4260-8f72-ffe52d43d696.jpg?v=1768343560',
  },
  
  // 2. The Aesthetic Minimalist（条件是题1选for-partner+题3选setup/home）
  'for-partner_setup-home': {
    number: '02',
    type: 'The Aesthetic Minimalist',
    img: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/2_e397bdf0-031b-4d40-b162-d22ba7c277c4.png?v=1768343387',
    url: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/2_88a45a7b-6149-4dab-bbd4-4014d6e6d6dd.jpg?v=1768343560',
  },
  
  // 3. The Group Chat MVP（条件是题1选for-family）
  'for-family': {
    number: '03',
    type: 'The Group Chat MVP',
    img: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/3_4259314c-cc36-448a-aa6f-190e872ba67a.png?v=1768343386',
    url: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/3_e0b8a88a-daf9-42ea-9a78-5a7824ad03eb.jpg?v=1768343560',
  },
  
  // 4. The Self-Appointed Soulmate（条件是题1选for-self）
  'for-self': {
    number: '04',
    type: 'The Self-Appointed Soulmate',
    img: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/4_1c95316c-0de8-42b7-9d06-d16297d18988.png?v=1768343387',
    url: 'https://cdn.shopify.com/s/files/1/0593/5398/9298/files/4_d0069f6c-df7e-47b8-9610-6804baa72bc6.jpg?v=1768343560',
  }
};

function savePersonaCard() {
  try {
    // 获取当前人格类型
    const persona = determinePersonaType();
    
    // 方法1：直接下载（如果图片支持跨域）
    downloadImageWithXHR(persona.img, persona.type);
    
    // 或者方法2：在新标签页打开图片让用户手动保存
    // openImageInNewTab(persona.img);
    
  } catch (error) {
    console.error('Error saving persona card:', error);
    alert('Failed to save persona card. Please try again.');
  }
}

// 使用XMLHttpRequest下载图片
function downloadImageWithXHR(imageUrl, filename) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', imageUrl, true);
    xhr.responseType = 'blob';
    
    xhr.onload = function() {
      if (xhr.status === 200) {
        const blob = xhr.response;
        const downloadUrl = window.URL.createObjectURL(blob);
        
        const downloadLink = document.createElement('a');
        downloadLink.href = downloadUrl;
        downloadLink.download = filename;
        
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        
        // 释放URL对象
        setTimeout(() => {
          window.URL.revokeObjectURL(downloadUrl);
          resolve();
        }, 100);
      } else {
        reject(new Error(`XHR error: ${xhr.status}`));
      }
    };
    
    xhr.onerror = function() {
      reject(new Error('Network error'));
    };
    
    xhr.send();
  });
}

function downloadImageDirectly(imageUrl, filename) {
  // 创建一个隐藏的a标签
  const downloadLink = document.createElement('a');
  downloadLink.href = imageUrl;
  downloadLink.download = filename;
  downloadLink.style.display = 'none';
  
  // 添加到页面并触发点击
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  
  // 显示成功提示
  showSaveSuccessMessage();
}

// 方法2：在新标签页打开图片（用户可右键另存为）
function openImageInNewTab(imageUrl) {
  window.open(imageUrl, '_blank');

  setTimeout(() => {
    if (newWindow && !newWindow.closed) {
      const message = 'Persona card opened in new tab. Right-click on the image and select "Save image as..." to save it.';
      alert(message);
    }
  }, 300); // 300-500ms延迟足够
}

// 翻转卡片
function flipCard() {
  const card = document.getElementById('personaCard');
  // card.classList.toggle('flipped');

  // updatePersonaCard();
    const persona = determinePersonaType();
  
  // 更新DOM元素
  const frontElement = document.querySelector('.card-front-rotate');
  
  if (frontElement) {
    frontElement.className = 'card-front'; // 重置类
    frontElement.classList.add(`persona-${persona.number}`);
  }
}

// 根据用户答案确定人格类型
function determinePersonaType() {
  const q1 = userAnswers[0]; // 第一题答案
  const q3 = userAnswers[2]; // 第三题答案
  
  let personaKey = '';
  
  // 逻辑判断
  if (q1 === 'for-partner') {
    if (q3 === 'setup' || q3 === 'home') {
      personaKey = 'for-partner_setup-home'; // Aesthetic Minimalist
    } else {
      personaKey = 'for-partner_not-home'; // Designated Adult
    }
  } else if (q1 === 'for-family') {
    personaKey = 'for-family'; // Group Chat MVP
  } else if (q1 === 'for-self') {
    personaKey = 'for-self'; // Self-Appointed Soulmate
  } else if (q1 === 'for-friends') {
    // 朋友选项没有特定人格，使用默认或随机
    personaKey = 'for-partner_not-home'; // 默认
  }
  
  // 如果没有匹配，使用默认
  if (!personaKey || !personaTypes[personaKey]) {
    personaKey = 'for-partner_not-home';
  }
  
  return personaTypes[personaKey];
}

// 更新人格卡片内容
function updatePersonaCard() {
  const persona = determinePersonaType();
  
  // 更新DOM元素
  const frontElement = document.querySelector('.card-front');
  
  if (frontElement) {
    frontElement.className = 'card-front'; // 重置类
    frontElement.classList.add(`persona-${persona.number}`);
  }
  
  // 重置卡片为背面
  // const card = document.getElementById('personaCard');
  // if (card) {
  //   card.classList.remove('flipped');
  // }
  
  console.log('人格类型:', persona.type);
}


// 显示结果页面并筛选产品
function showResult() {
  console.log('用户答案:', userAnswers);
  
  document.getElementById('resultContainer').style.display = 'block';
  
  // 更新进度条到结果状态
  updateProgressBar(3);
  
  // 筛选并显示匹配的产品
  filterAndDisplayProducts();
}

// 筛选并显示产品
function filterAndDisplayProducts() {
  const allProductCards = document.querySelectorAll('.valentine-pool-grid .product-card');
  console.log('总产品数:', allProductCards.length);
  console.log('用户答案数组:', userAnswers);
  
  // 步骤1: 只筛选有库存的产品
  const availableProducts = Array.from(allProductCards).filter(card => 
    card.dataset.available === 'true'
  );
  console.log('有库存产品:', availableProducts.length);
  
  // 步骤2: 优先匹配三个标签都符合的
  let matchedProducts = availableProducts.filter(card => {
    const productTags = card.dataset.tags.split(',').map(tag => tag.trim());
    
    // 检查产品是否包含所有三个用户答案标签
    return userAnswers.every(userTag => 
      productTags.includes(userTag)
    );
  });
  
  console.log('完全匹配三个标签的产品数:', matchedProducts.length);
  
  // 步骤3: 如果完全匹配不足2个，放宽条件（第三题可以不匹配）
  if (matchedProducts.length < 2) {
    const relaxedMatch = availableProducts.filter(card => {
      const productTags = card.dataset.tags.split(',').map(tag => tag.trim());
      
      // 只匹配前两个标签
      return productTags.includes(userAnswers[0]) && 
             productTags.includes(userAnswers[1]);
      // 第三题不要求匹配
    });
    
    console.log('放宽匹配（前两个标签）的产品数:', relaxedMatch.length);
    
    // 合并结果，去重
    const allMatches = [...matchedProducts];
    relaxedMatch.forEach(card => {
      if (!allMatches.find(p => p.dataset.id === card.dataset.id)) {
        allMatches.push(card);
      }
    });
    
    matchedProducts = allMatches;
  }
  
  console.log('合并后产品数:', matchedProducts.length);
  
  // 隐藏所有产品
  allProductCards.forEach(card => {
    card.style.display = 'none';
  });

  // 只显示前6个产品
  const MAX_DISPLAY = isMobile() ? MAX_DISPLAY_MOBILE : MAX_DISPLAY_PC;
  matchedProducts.forEach((card, index) => {
    if (index < MAX_DISPLAY) {
      card.style.display = 'block';
    }
  });
  
  // 更新布局
  updateProductsGridLayout(Math.min(matchedProducts.length, MAX_DISPLAY));
  
  // 添加或更新"Show More"按钮
  addShowMoreButton(matchedProducts);
  
}

function addShowMoreButton(matchedProducts) {
  const productsContainer = document.querySelector('.products-container');
  
  // 移除已存在的按钮
  const existingButton = document.getElementById('showMoreButton');
  if (existingButton) {
    existingButton.remove();
  }
  // 如果产品数量超过6个，添加"Show More"按钮
  const MAX_DISPLAY = isMobile() ? MAX_DISPLAY_MOBILE : MAX_DISPLAY_PC;
  if (matchedProducts.length > MAX_DISPLAY) {
    const showMoreButton = document.createElement('button');
    showMoreButton.id = 'showMoreButton';
    showMoreButton.className = 'show-more-button';
    showMoreButton.textContent = `Show More`;
    showMoreButton.dataset.isExpanded = 'false'; // 添加状态标记
    
    // 存储matchedProducts在按钮的data属性中
    showMoreButton.dataset.totalProducts = matchedProducts.length;
    
    // 添加点击事件 - 切换显示所有产品或只显示6个
    showMoreButton.addEventListener('click', function() {
      const isExpanded = this.dataset.isExpanded === 'true';
      
      if (!isExpanded) {
        // 展开：显示所有产品
        matchedProducts.forEach((card, index) => {
          card.style.display = 'block';
        });
        
        // 更新网格布局
        updateProductsGridLayout(matchedProducts.length);
        
        // 更新按钮文本和状态
        this.textContent = 'Show Less';
        this.dataset.isExpanded = 'true';
        this.classList.add('expanded');
      } else {
        // 收起：只显示前6个产品
        matchedProducts.forEach((card, index) => {
          card.style.display = index < MAX_DISPLAY ? 'block' : 'none';
        });
        
        // 更新网格布局
        updateProductsGridLayout(MAX_DISPLAY);
        
        // 更新按钮文本和状态
        this.textContent = `Show More`;
        this.dataset.isExpanded = 'false';
        this.classList.remove('expanded');
      }
    });
    
    // 将按钮添加到产品网格后面
    const productsGrid = document.getElementById('productsGrid');
    productsContainer.insertBefore(showMoreButton, productsGrid.nextSibling);
  }
}


// 随机打乱数组（现在只用于兜底产品选择）
function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

// 更新产品网格布局
function updateProductsGridLayout(productCount) {
  const productsGrid = document.getElementById('productsGrid');
  
  // 根据产品数量调整网格布局
  if (productCount === 1) {
    productsGrid.style.gridTemplateColumns = '1fr';
    productsGrid.style.justifyContent = 'center';
  } else if (productCount === 2) {
    productsGrid.style.gridTemplateColumns = 'repeat(2, 1fr)';
  } else {
    productsGrid.style.gridTemplateColumns = 'repeat(3, 1fr)';
  }
}

// 重新筛选产品（当用户重新答题时）
function refilterProducts() {
  const allProductCards = document.querySelectorAll('.valentine-pool-grid .product-card');
  
  // 先隐藏所有产品
  allProductCards.forEach(card => {
    card.style.display = 'none';
  });
  
  // 隐藏提示信息
  const noProductsMessage = document.querySelector('.no-products-message');
  if (noProductsMessage) {
    noProductsMessage.style.display = 'none';
  }
  // 移除已存在的"Show More"按钮
  const existingButton = document.getElementById('showMoreButton');
  if (existingButton) {
    existingButton.remove();
  }
  // 重置网格布局
  const productsGrid = document.getElementById('productsGrid');
  productsGrid.style.gridTemplateColumns = 'repeat(auto-fit, minmax(250px, 1fr))';
  productsGrid.style.justifyContent = '';
}

// 修改重启答题函数
function restartQuiz() {
  document.getElementById('quizContainer').style.display = 'block';
  document.getElementById('resultContainer').style.display = 'none';
  
  // 重置答题状态
  resetQuiz();
  
  // 重置产品显示
  refilterProducts();
}

function resetQuiz() {
  userAnswers = [null, null, null]; // 固定长度为3的数组
  
  // 重置所有选项选中状态
  document.querySelectorAll('.option').forEach(option => {
    option.classList.remove('selected');
  });
  
  // 重置进度条
  updateProgressBar(0);

  // 重置卡片到背面
  const card = document.getElementById('personaCard');
  if (card) {
    card.classList.remove('flipped');
  }
  
  // 显示第一题
  goToQuestion(1);
}

// 提交后 Shopify 会自动处理:
// - 新邮箱: 发送验证邮件
// - 已存在: 返回错误提示
document.getElementById('email-form').addEventListener('submit', async (e) => {
  e.preventDefault();
  const emailInput = document.getElementById('email-input');
  const email = emailInput.value.trim(); // 加trim()处理首尾空格，避免空字符干扰
  const errorMsg = document.getElementById('error-message');
  const submitBtn = document.getElementById('email-submit-btn');

  errorMsg.textContent = '';
  
  // 前端格式验证
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^[^\s@]+@[^\s@.]+\.[^\s@]{2,}$/;

  if (!email) {
    errorMsg.textContent = 'Please enter your email';
    return;
  }
  
  if (!emailRegex.test(email)) {
    errorMsg.textContent = 'The email format is incorrect';
    return;
  }

  errorMsg.textContent = '';
  submitBtn.disabled = true;
  try {
    // 检查邮箱是否已注册
    const check = await checkEmail(email);

    if(check.hasValentineReward){
      // 老邮箱且领取过
      errorMsg.textContent = 'You have already claimed it';
      setTimeout(() => {
        errorMsg.textContent = '';
      }, 3000);
    } else if (check.registered) {
      // 老邮箱 - 直接显示奖励
      errorMsg.textContent = '✅ Verification successful!';
      errorMsg.style.color = 'green';
      customerId = check.customerId;
      await showRewardResult();
    } else {
      // 新邮箱 - 发送验证邮件
      errorMsg.textContent = '';
      await sendVerificationEmail(email);
      showVerificationModal(email);
    }
  } catch (error) {
    console.error('Error:', error);
    errorMsg.textContent = 'Something went wrong. Please try again.';
  } finally {
    submitBtn.disabled = false;
  }
});

async function checkEmail(email) {
  console.log("检查邮箱：", email);
  const response = await fetch(`${API_URL}/check-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });
  const result = await response.json();
  return result;
}

// 发送验证邮件
async function sendVerificationEmail(email) {
  const response = await fetch(`${API_URL}/send-verification`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });
  return await response.json();
}

// 显示验证邮件已发送弹窗
function showVerificationModal(email) {
  const modal = document.getElementById('email-modal');
  
  // 显示验证邮件已发送步骤
  document.getElementById('verification-sent').style.display = 'block';
  document.getElementById('reward-result').style.display = 'none';
  document.getElementById('verification-failed').style.display = 'none';
  
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // 绑定按钮事件
  document.getElementById('verified-btn').onclick = () => checkVerificationStatus(email);
  document.getElementById('resend-btn').onclick = () => resendVerification(email);
}

// 检查验证状态
async function checkVerificationStatus(userEmail) {
  const verifiedBtn = document.getElementById('verified-btn');
  const originalText = verifiedBtn.textContent;
  
  verifiedBtn.disabled = true;
  verifiedBtn.textContent = 'Checking...';

  console.log('再次检查');
  
  try {
    // 再次检查邮箱状态
    const check = await checkEmail(userEmail);
    
    if (check.registered) {
      customerId = check.customerId;
      // 验证成功，显示奖励
      await showRewardResult();
    } else {
      // 验证失败
      showVerificationFailed();
    }
  } catch (error) {
    console.error('Verification check failed:', error);
    showVerificationFailed();
  } finally {
    verifiedBtn.disabled = false;
    verifiedBtn.textContent = originalText;
  }
}

// 显示奖励结果
async function showRewardResult() {
  const modal = document.getElementById('email-modal');
  
  document.getElementById('discount-code').textContent = LOVE_DISCOUNT;
  const discountReward = document.getElementById('discount-reward');
  const giftReward = document.getElementById('gift-reward');
  
  // 2. 生成0-99的随机数，实现98%/2%的概率
  const randomNum = Math.floor(Math.random() * 100);
  
  // 3. 根据随机数显示对应奖励项
  if (randomNum < 98) {
    // 98%概率显示折扣码
    discountReward.style.display = 'block';
    await addCustomerTag('valentine_reward_15', customerId);
  } else {
    // 2%概率显示神秘礼物
    giftReward.style.display = 'block';
    await addCustomerTag('valentine_reward_d5cc', customerId);
    // 加标签
  }
  
  // 显示奖励步骤
  document.getElementById('verification-sent').style.display = 'none';
  document.getElementById('reward-result').style.display = 'block';
  document.getElementById('verification-failed').style.display = 'none';
  
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // 保存到本地存储，避免重复显示
  localStorage.setItem('valentine_reward_shown', 'true');
  localStorage.setItem('valentine_discount_code', LOVE_DISCOUNT);
}

function showVerificationFailed() {
  const modal = document.getElementById('email-modal');
  
  document.getElementById('verification-sent').style.display = 'none';
  document.getElementById('reward-result').style.display = 'none';
  document.getElementById('verification-failed').style.display = 'block';
  
  modal.style.display = 'block';
}

// 重新发送验证邮件
async function resendVerification(email) {
  const resendBtn = document.getElementById('resend-btn');
  const originalText = resendBtn.textContent;
  
  resendBtn.disabled = true;
  resendBtn.textContent = 'Sending...';
  
  try {
    await sendVerificationEmail(email);
    alert('Verification email resent successfully!');
  } catch (error) {
    alert('Failed to resend email. Please try again.');
  } finally {
    resendBtn.disabled = false;
    resendBtn.textContent = originalText;
  }
}

async function addCustomerTag(tag, id) {
  try {
    console.log('🏷️ 为用户添加标签:', tag);
    
    // 这里需要调用Shopify API来为用户添加标签
    
    const response = await fetch('https://service-iniushop.xyz/api/add-customer-tag', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: `gid://shopify/Customer/${id}`,
        tags: tag
      })
    });
    
    if (response.ok) {
      console.log('✅ 标签添加成功');
      showNotification('Gift Card has been sent to your email');
    } else {
      console.warn('⚠️ 标签添加失败，但抽奖结果有效');
    }
    
  } catch (error) {
    console.error('添加标签失败:', error);
    // 即使标签添加失败，也不影响抽奖结果
  }
}

function copyCode(code) {
  const copyBtn = document.getElementById('copyBtn');
  
  // 复制文本到剪贴板
  navigator.clipboard.writeText(code)
    .then(() => {
      // 按钮状态变化
      copyBtn.textContent = 'copied!';
      copyBtn.classList.add('copied');
      
      // 2秒后恢复原状态
      setTimeout(() => {
        copyBtn.textContent = 'copy';
        copyBtn.classList.remove('copied');
      }, 2000);
    })
    .catch(err => {
      console.error('复制失败:', err);
    });
}

// 隐藏弹窗
function hideModal() {
  const modal = document.getElementById('email-modal');
  modal.style.display = 'none';
  document.body.style.overflow = '';
}

// 关闭弹窗时点击遮罩层
document.querySelector('.modal-overlay').addEventListener('click', hideModal);

// 防止表单在弹窗内点击时关闭
document.querySelector('.modal-content').addEventListener('click', function(e) {
  e.stopPropagation();
});